module.exports = __webpack_public_path__ + "img/abroad-img2.81e8e95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/student-enquiry-form/abroad-img2.png
// module id = 1670
// module chunks = 1